import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Title from "../../components/Title";
import './profile.css';
import { FiUser, FiUpload } from "react-icons/fi";
import avatar from '../../assets/avatar.png';
import { AuthContext } from "../../contexts/auth";
import { deleteDoc, doc, collection, query, where, getDocs, updateDoc } from "@firebase/firestore";
import { db, storage } from '../../services/firebaseConnection';
import { ref, uploadBytes, getDownloadURL } from "@firebase/storage";
import { toast } from "react-toastify";

export default function Profile() {
    const { user, storageUser, setUser } = useContext(AuthContext);

    const [avatarUrl, setAvatarUrl] = useState(user?.avatarUrl || '');
    const [imageAvatar, setImageAvatar] = useState(null);
    const [nome, setNome] = useState(user?.nome || '');
    const [email, setEmail] = useState(user?.email || '');
    const [username, setUsername] = useState(user?.username || '');
    const navigate = useNavigate();

    function handleFile(e) {
        if (e.target.files[0]) {
            const image = e.target.files[0];
            if (image.type === 'image/jpeg' || image.type === 'image/png') {
                setImageAvatar(image);
                setAvatarUrl(URL.createObjectURL(image));
            } else {
                toast.error("Envie uma imagem do tipo PNG ou JPEG");
                setImageAvatar(null);
            }
        }
    }

    async function handleDeleteUser() {
        if (user?.user_id) {
            await deleteUserAndData(user.user_id);
            setUser(null);
            storageUser(null);
            navigate('/');
        }
    }

    async function deleteUserAndData(userId) {
        if (!userId) {
            throw new Error("User ID is not defined");
        }

        try {
            const userDocRef = doc(db, "users", userId);
            await deleteDoc(userDocRef);

            const postsQuery = query(collection(db, "posts"), where("userId", "==", userId));
            const postsSnapshot = await getDocs(postsQuery);
            postsSnapshot.forEach(async (postDoc) => {
                await deleteDoc(postDoc.ref);
            });

            const commentsQuery = query(collection(db, "comments"), where("userId", "==", userId));
            const commentsSnapshot = await getDocs(commentsQuery);
            commentsSnapshot.forEach(async (commentDoc) => {
                await deleteDoc(commentDoc.ref);
            });

            toast.success("Usuário e dados deletados com sucesso!");
        } catch (error) {
            console.error("Erro ao deletar usuário e dados:", error);
            toast.error("Erro ao deletar. Tente novamente.");
        }
    }

    async function handleUpload() {
        try {
            if (!user?.user_id) {
                throw new Error('User ID is not defined');
            }

            const currentUid = user.user_id;
            console.log('UID:', currentUid);

            const uploadRef = ref(storage, `images/${currentUid}/${imageAvatar.name}`);

            const snapshot = await uploadBytes(uploadRef, imageAvatar);
            const downloadURL = await getDownloadURL(snapshot.ref);
            const docRef = doc(db, "users", user.user_id);
            console.log('Download URL:', downloadURL);
            console.log('Updating document with ID:', user.user_id);
            await updateDoc(docRef, {
                avatarUrl: downloadURL,
                nome: nome,
                username: username
            });
            const updatedUser = {
                ...user,
                nome: nome,
                username: username,
                avatarUrl: downloadURL
            };
            setUser(updatedUser);
            storageUser(updatedUser);
            toast.success("Atualizado com sucesso!");
        } catch (error) {
            console.error('Erro no upload:', error);
            toast.error("Erro ao atualizar. Tente novamente.");
        }
    }

    async function handleSubmit(e) {
        e.preventDefault();

        if (nome !== '') {
            if (imageAvatar === null) {
                try {
                    if (!user?.user_id) {
                        throw new Error('User ID is not defined');
                    }
                    const docRef = doc(db, "users", user.user_id);
                    console.log('Atualizando documento sem imagem. UID:', user.user_id);
                    await updateDoc(docRef, {
                        nome: nome,
                        username: username
                    });
                    const updatedUser = {
                        ...user,
                        nome: nome,
                        username: username
                    };
                    setUser(updatedUser);
                    storageUser(updatedUser);
                    toast.success("Atualizado com sucesso!");
                } catch (error) {
                    console.error('Erro no upload:', error);
                    toast.error("Erro ao atualizar. Tente novamente.");
                }
            } else {
                handleUpload();
            }
        }
    }

    return (
        <div className="app">
            <Header />
            <div className="content">
                <Title name="Perfil">
                    <FiUser size={25} />
                </Title>

                <div className="container">
                    <form className="form-profile" onSubmit={handleSubmit}>
                        <label className="label-avatar">
                            <span>
                                <FiUpload color="#FFF" size={25} />
                            </span>
                            <input type="file" accept="image/*" onChange={handleFile} /> <br />
                            {avatarUrl === null ? (
                                <img src={avatar} alt="Foto de perfil" width={250} height={250} />
                            ) : (
                                <img src={avatarUrl} alt="Foto de perfil" width={250} height={250} />
                            )}
                        </label>

                        <label>Nome:</label>
                        <input type="text" value={nome} onChange={(e) => setNome(e.target.value)} className="mb-3" />

                        <label>Nome de usuário:</label>
                        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="mb-3" />

                        <label>Email:</label>
                        <input type="text" value={email} disabled={true} className="mb-3" />

                        <button type="submit" className="mb-3 action-button btn btn-success btn-lg">Salvar</button>
                        <button type="button" onClick={handleDeleteUser} className="btn-delete action-button btn btn-danger btn-lg">
                            Deletar Conta
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
